import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, TransitionGroup as _TransitionGroup, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-653b78c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-details" }
const _hoisted_2 = { class: "callout callout--warning" }
const _hoisted_3 = { viewBox: "0 0 24 24" }
const _hoisted_4 = ["d"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { viewBox: "0 0 24 24" }
const _hoisted_8 = ["d"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_13 = { viewBox: "0 0 24 24" }
const _hoisted_14 = ["d"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We recommend using multifactor authentication (MFA) to strengthen account security. Disabling MFA will remove it from this account entirely.", -1))
const _hoisted_16 = { viewBox: "0 0 24 24" }
const _hoisted_17 = ["d"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click \"Continue\", and then save to disable.", -1))
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = { class: "d-flex justify-content-between row g-0" }
const _hoisted_21 = { class: "col text-wrap text-truncate" }
const _hoisted_22 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_23 = {
  class: "new-name",
  key: "noname"
}
const _hoisted_24 = { class: "col-auto ms-auto align-self-end align-self-sm-start me-sm-2" }
const _hoisted_25 = { class: "mt-sm-0 d-flex col-sm-auto mt-2 col-12 col-sm-auto" }
const _hoisted_26 = {
  key: 0,
  class: "mb-2 mb-sm-0 me-sm-2"
}
const _hoisted_27 = { class: "ms-auto" }
const _hoisted_28 = {
  key: 0,
  class: "callout callout--warning callout--in-content"
}
const _hoisted_29 = { viewBox: "0 0 24 24" }
const _hoisted_30 = ["d"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { viewBox: "0 0 24 24" }
const _hoisted_34 = ["d"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "\"Save User\"", -1))
const _hoisted_38 = { viewBox: "0 0 24 24" }
const _hoisted_39 = ["d"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "We recommend using multifactor authentication (MFA) to strengthen account security. Disabling MFA will remove it from this account entirely.", -1))
const _hoisted_41 = { viewBox: "0 0 24 24" }
const _hoisted_42 = ["d"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Click \"Continue\", and then save to disable.", -1))
const _hoisted_44 = { class: "dt-container" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6 p-0 pe-md-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "el-form-item__label" }, "Name")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Name of this user", -1))
const _hoisted_50 = { class: "col-md-6 p-0 ps-md-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-form-item__label" }, "Email Address", -1))
const _hoisted_52 = {
  key: 1,
  class: "ms-2",
  "aria-hidden": "true"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email address of this user", -1))
const _hoisted_54 = { class: "row" }
const _hoisted_55 = {
  key: 0,
  class: "col-md-6 p-0 pe-md-2 transition"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "el-form-item__label" }, "Role", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Assigned role for this user", -1))
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Contact your Ditto account admin to change your role.", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You cannot change your own role. Contact another Ditto account admin to change your role.", -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = {
  key: 0,
  class: "transition col-md-6 p-0 ps-md-2"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Multifactor Authentication", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "User will be required to set up MFA application on mobile device", -1))
const _hoisted_69 = { class: "row" }
const _hoisted_70 = {
  key: 0,
  class: "col-md-6 p-0 pe-md-2 transition"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "An email will be sent", -1))
const _hoisted_72 = {
  key: 0,
  class: "row"
}
const _hoisted_73 = { class: "col-md-6 p-0 pe-md-2 transition" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      title: (_ctx.userOriginalCopyMFA ? 'Disable' : 'Enable') + ' Multifactor Authentication',
      modelValue: _ctx.mfaModalVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mfaModalVisible) = $event)),
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mfaModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.continueMfaModalHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode("Continue")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          (!_ctx.userOriginalCopyMFA)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_4)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, "To complete setup, you will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator, to complete MFA setup and log in again.")
                      ]))
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_8)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_10,
                        _createTextVNode(" & log out.")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_12,
                        _createTextVNode(". "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will be logged out of the Ditto account portal immediately.")
                      ]))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_13, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_14)
                  ])),
                  _hoisted_15
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_16, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_17)
                  ])),
                  _hoisted_18
                ])
              ], 64))
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h1", _hoisted_21, [
        (_ctx.isMe)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" My Account " + _toDisplayString(_ctx.user.isSSOGenerated ? '(SSO)' : ''), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_router_link, {
                class: "primary-color",
                to: "/users"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Users")
                ]),
                _: 1
              }),
              _createTextVNode(" » "),
              _createVNode(_Transition, {
                name: "fade-in",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_ctx.user.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_TransitionGroup, {
                          class: "transition",
                          name: _ctx.user.name.length > 1 ? 'fade-in' : '',
                          key: "name"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user.name, (letter, i) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "transition",
                                key: i
                              }, _toDisplayString(letter), 1))
                            }), 128)),
                            _createTextVNode(" " + _toDisplayString(_ctx.user.isSSOGenerated ? '(SSO)' : ''), 1)
                          ]),
                          _: 1
                        }, 8, ["name"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, " User name " + _toDisplayString(_ctx.user.isSSOGenerated ? '(SSO)' : ''), 1))
                ]),
                _: 1
              })
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (!_ctx.isMe && !_ctx.creationMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _ctx.onDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete User")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_el_button, {
            onClick: _ctx.onSave,
            type: "primary",
            disabled: _ctx.saving
          }, {
            default: _withCtx(() => [
              false
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Create ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.creationMode ? 'Create' : 'Save'), 1)
                  ], 64)),
              _createTextVNode(" User ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    (_ctx.warningHasChanged)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
          (!_ctx.userOriginalCopyMFA)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_29, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_30)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "To complete setup, you will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will need a mobile device with a multifactor authentication (MFA) app, such as Google Authenticator, to complete MFA setup and log in again.")
                      ]))
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_33, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_34)
                  ])),
                  (_ctx.isMe)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "To enable MFA, you must click \"Save User\" & log out."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _createTextVNode("To enable MFA, you must click "),
                        _hoisted_37,
                        _createTextVNode(". "),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.user.name), 1),
                        _createTextVNode(" will be logged out of the Ditto account portal immediately.")
                      ]))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_38, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_39)
                  ])),
                  _hoisted_40
                ]),
                _createElementVNode("li", null, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_41, [
                    _createElementVNode("path", { d: _ctx.mdiAlertCircleOutline }, null, 8, _hoisted_42)
                  ])),
                  _hoisted_43
                ])
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_44, [
      (_ctx.creationMode)
        ? (_openBlock(), _createElementBlock("p", _hoisted_45, "To give someone access to the Ditto Settings Portal, add them as a user below. This person will be able to edit Ditto account settings."))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        model: _ctx.user,
        "hide-required-asterisk": "",
        ref: "userForm",
        "label-position": "top",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_el_form_item, { prop: "name" }, {
                default: _withCtx(() => [
                  _hoisted_48,
                  _hoisted_49,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.user.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.name) = $event)),
                    placeholder: "User Name",
                    disabled: _ctx.user.isSSOGenerated
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_el_form_item, { prop: "email" }, {
                default: _withCtx(() => [
                  _createElementVNode("label", null, [
                    _hoisted_51,
                    (!_ctx.user.is_verified && !_ctx.creationMode)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-form-item__subtitle-link",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onResendVerificationEmail && _ctx.onResendVerificationEmail(...args)))
                        }, _toDisplayString(_ctx.resendingVerificationEmail ? 'Sending...' : 'Resend Verification Email'), 1))
                      : _createCommentVNode("", true),
                    (_ctx.resendingVerificationEmail)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_52, null, 512)), [
                          [_directive_loading, _ctx.resendingVerificationEmail]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_53,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.user.email,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.email) = $event)),
                    placeholder: "Email",
                    onChange: _ctx.emailChanged,
                    disabled: _ctx.user.isSSOGenerated
                  }, null, 8, ["modelValue", "onChange", "disabled"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createVNode(_Transition, { name: "slide-in-top-large" }, {
              default: _withCtx(() => [
                (!_ctx.creationMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createVNode(_component_el_form_item, { prop: "roleName" }, {
                        default: _withCtx(() => [
                          _createElementVNode("label", null, [
                            _hoisted_56,
                            _createVNode(_component_router_link, {
                              class: "el-form-item__subtitle-link",
                              to: "/roles/"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Manage Roles ")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_57,
                          _createVNode(_component_el_tooltip, {
                            placement: "top",
                            disabled: _ctx.isAdmin && !_ctx.isMe
                          }, {
                            content: _withCtx(() => [
                              (!_ctx.isAdmin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                                : (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                disabled: _ctx.saving || (_ctx.isAdmin && _ctx.isMe) || !_ctx.isAdmin,
                                filterable: "",
                                modelValue: _ctx.user.role,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.role) = $event)),
                                "value-key": "id"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRoles, (role) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: role.id,
                                      label: role.name,
                                      value: role.id,
                                      disabled: !_ctx.hasRoles && !role.readOnly
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, [
                                          _createVNode(_component_el_tooltip, {
                                            effect: "dark",
                                            content: "Upgrade your Ditto account to unlock roles.",
                                            placement: "bottom",
                                            "hide-after": 0,
                                            disabled: _ctx.hasRoles || role.readOnly
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(role.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["disabled"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value", "disabled"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["disabled", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.creationMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createVNode(_component_el_form_item, { prop: "MFA" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        "show-after": 250,
                        "hide-after": 0,
                        placement: "top",
                        disabled: _ctx.canToggleMFA
                      }, {
                        content: _withCtx(() => [
                          (_ctx.user.ownerSetMFA)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createElementVNode("p", null, "MFA " + _toDisplayString(_ctx.user.MFA ? 'enabled' : 'disabled') + " by a Ditto Account Portal administrator.", 1),
                                _createElementVNode("p", null, [
                                  _createElementVNode("em", null, "Contact your IT department if you wish to " + _toDisplayString(_ctx.user.MFA ? 'disable' : 'enable') + " it.", 1)
                                ])
                              ]))
                            : (!_ctx.user.is_verified)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, " MFA can only be enabled for verified users. "))
                              : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("label", {
                            class: _normalizeClass({ disabled : !_ctx.canToggleMFA })
                          }, [
                            _createVNode(_component_el_switch, {
                              disabled: _ctx.switchIsDisabled,
                              onInput: _ctx.mfaInputHandler,
                              value: _ctx.user.MFA
                            }, null, 8, ["disabled", "onInput", "value"]),
                            _hoisted_67
                          ], 2)
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _hoisted_68
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_Transition, { name: "slide-in-top-large" }, {
              default: _withCtx(() => [
                (!_ctx.creationMode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createVNode(_component_el_form_item, { label: "Reset Password" }, {
                        default: _withCtx(() => [
                          _hoisted_71,
                          _createVNode(_component_el_button, {
                            onClick: _ctx.onResetPassword,
                            disabled: _ctx.user.isSSOGenerated
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Reset Password")
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (!_ctx.creationMode && _ctx.showOnboardingButton)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                _createVNode(_Transition, { name: "slide-in-top-large" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_el_form_item, {
                        class: "ditto-setup-tutorial mb-md-0",
                        label: "Ditto Setup Tutorial"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.tutorialText), 1),
                          _createVNode(_component_el_button, { onClick: _ctx.onStartOnboarding }, {
                            default: _withCtx(() => [
                              _createTextVNode("Ditto Setup Tutorial")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}